import { useEffect } from 'react';
import { Language } from 'intermind';

// Use .../**dist**/... pattern to avoid tree-shaking issues
import 'moment/dist/locale/ar';
import 'moment/dist/locale/cs';
import 'moment/dist/locale/de';
import 'moment/dist/locale/es';
import 'moment/dist/locale/fr';
import 'moment/dist/locale/hi';
import 'moment/dist/locale/hu';
import 'moment/dist/locale/it';
import 'moment/dist/locale/ja';
import 'moment/dist/locale/ko';
import 'moment/dist/locale/nl';
import 'moment/dist/locale/pl';
import 'moment/dist/locale/pt';
import 'moment/dist/locale/ru';
import 'moment/dist/locale/tr';
import 'moment/dist/locale/zh-cn';

import { useSettingsStore } from '@/store/SettingsStore.ts';
import moment from 'moment';

const momentLocaleMap: Record<Language, string> = {
  [Language.ARABIC]: 'ar',
  [Language.CZECH]: 'cs',
  [Language.GERMAN]: 'de',
  [Language.ENGLISH]: 'en',
  [Language.SPANISH]: 'es',
  [Language.FRENCH]: 'fr',
  [Language.HINDI]: 'hi',
  [Language.HUNGARIAN]: 'hu',
  [Language.ITALIAN]: 'it',
  [Language.JAPANESE]: 'ja',
  [Language.KOREAN]: 'ko',
  [Language.DUTCH]: 'nl',
  [Language.POLISH]: 'pl',
  [Language.PORTUGUESE]: 'pt',
  [Language.RUSSIAN]: 'ru',
  [Language.TURKISH]: 'tr',
  [Language.CHINESE]: 'zh-cn',
};

export function useSyncMomentLocale() {
  const language = useSettingsStore((state) => state.language);

  useEffect(() => {
    const momentLocale = momentLocaleMap[language] || 'en';
    const result = moment.locale(momentLocale);

    if (result !== momentLocale) {
      console.warn(`moment.locale("${momentLocale}") failed — got: ${result}`);
    }
  }, [language]);
}
